function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/utils/selection
 */
import TableWalker from '../tablewalker';
/**
 * Returns all model table cells that are fully selected (from the outside)
 * within the provided model selection's ranges.
 *
 * To obtain the cells selected from the inside, use
 * {@link module:table/utils/selection~getTableCellsContainingSelection}.
 *
 * @param {module:engine/model/selection~Selection} selection
 * @returns {Array.<module:engine/model/element~Element>}
 */

export function getSelectedTableCells(selection) {
  var cells = [];

  var _iterator = _createForOfIteratorHelper(sortRanges(selection.getRanges())),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var range = _step.value;
      var element = range.getContainedElement();

      if (element && element.is('element', 'tableCell')) {
        cells.push(element);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return cells;
}
/**
 * Returns all model table cells that the provided model selection's ranges
 * {@link module:engine/model/range~Range#start} inside.
 *
 * To obtain the cells selected from the outside, use
 * {@link module:table/utils/selection~getSelectedTableCells}.
 *
 * @param {module:engine/model/selection~Selection} selection
 * @returns {Array.<module:engine/model/element~Element>}
 */

export function getTableCellsContainingSelection(selection) {
  var cells = [];

  var _iterator2 = _createForOfIteratorHelper(selection.getRanges()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var range = _step2.value;
      var cellWithSelection = range.start.findAncestor('tableCell');

      if (cellWithSelection) {
        cells.push(cellWithSelection);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return cells;
}
/**
 * Returns all model table cells that are either completely selected
 * by selection ranges or host selection range
 * {@link module:engine/model/range~Range#start start positions} inside them.
 *
 * Combines {@link module:table/utils/selection~getTableCellsContainingSelection} and
 * {@link module:table/utils/selection~getSelectedTableCells}.
 *
 * @param {module:engine/model/selection~Selection} selection
 * @returns {Array.<module:engine/model/element~Element>}
 */

export function getSelectionAffectedTableCells(selection) {
  var selectedCells = getSelectedTableCells(selection);

  if (selectedCells.length) {
    return selectedCells;
  }

  return getTableCellsContainingSelection(selection);
}
/**
 * Returns an object with the `first` and `last` row index contained in the given `tableCells`.
 *
 *		const selectedTableCells = getSelectedTableCells( editor.model.document.selection );
 *
 *		const { first, last } = getRowIndexes( selectedTableCells );
 *
 *		console.log( `Selected rows: ${ first } to ${ last }` );
 *
 * @param {Array.<module:engine/model/element~Element>} tableCells
 * @returns {Object} Returns an object with the `first` and `last` table row indexes.
 */

export function getRowIndexes(tableCells) {
  var indexes = tableCells.map(function (cell) {
    return cell.parent.index;
  });
  return getFirstLastIndexesObject(indexes);
}
/**
 * Returns an object with the `first` and `last` column index contained in the given `tableCells`.
 *
 *		const selectedTableCells = getSelectedTableCells( editor.model.document.selection );
 *
 *		const { first, last } = getColumnIndexes( selectedTableCells );
 *
 *		console.log( `Selected columns: ${ first } to ${ last }` );
 *
 * @param {Array.<module:engine/model/element~Element>} tableCells
 * @returns {Object} Returns an object with the `first` and `last` table column indexes.
 */

export function getColumnIndexes(tableCells) {
  var table = tableCells[0].findAncestor('table');

  var tableMap = _toConsumableArray(new TableWalker(table));

  var indexes = tableMap.filter(function (entry) {
    return tableCells.includes(entry.cell);
  }).map(function (entry) {
    return entry.column;
  });
  return getFirstLastIndexesObject(indexes);
}
/**
 * Checks if the selection contains cells that do not exceed rectangular selection.
 *
 * In a table below:
 *
 *		┌───┬───┬───┬───┐
 *		│ a │ b │ c │ d │
 *		├───┴───┼───┤   │
 *		│ e     │ f │   │
 *		│       ├───┼───┤
 *		│       │ g │ h │
 *		└───────┴───┴───┘
 *
 * Valid selections are these which create a solid rectangle (without gaps), such as:
 *   - a, b (two horizontal cells)
 *   - c, f (two vertical cells)
 *   - a, b, e (cell "e" spans over four cells)
 *   - c, d, f (cell d spans over a cell in the row below)
 *
 * While an invalid selection would be:
 *   - a, c (the unselected cell "b" creates a gap)
 *   - f, g, h (cell "d" spans over a cell from the row of "f" cell - thus creates a gap)
 *
 * @param {Array.<module:engine/model/element~Element>} selectedTableCells
 * @param {module:table/tableutils~TableUtils} tableUtils
 * @returns {Boolean}
 */

export function isSelectionRectangular(selectedTableCells, tableUtils) {
  if (selectedTableCells.length < 2 || !areCellInTheSameTableSection(selectedTableCells)) {
    return false;
  } // A valid selection is a fully occupied rectangle composed of table cells.
  // Below we will calculate the area of a selected table cells and the area of valid selection.
  // The area of a valid selection is defined by top-left and bottom-right cells.


  var rows = new Set();
  var columns = new Set();
  var areaOfSelectedCells = 0;

  var _iterator3 = _createForOfIteratorHelper(selectedTableCells),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var tableCell = _step3.value;

      var _tableUtils$getCellLo = tableUtils.getCellLocation(tableCell),
          row = _tableUtils$getCellLo.row,
          column = _tableUtils$getCellLo.column;

      var rowspan = parseInt(tableCell.getAttribute('rowspan') || 1);
      var colspan = parseInt(tableCell.getAttribute('colspan') || 1); // Record row & column indexes of current cell.

      rows.add(row);
      columns.add(column); // For cells that spans over multiple rows add also the last row that this cell spans over.

      if (rowspan > 1) {
        rows.add(row + rowspan - 1);
      } // For cells that spans over multiple columns add also the last column that this cell spans over.


      if (colspan > 1) {
        columns.add(column + colspan - 1);
      }

      areaOfSelectedCells += rowspan * colspan;
    } // We can only merge table cells that are in adjacent rows...

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var areaOfValidSelection = getBiggestRectangleArea(rows, columns);
  return areaOfValidSelection == areaOfSelectedCells;
}
/**
 * Returns array of sorted ranges.
 *
 * @param {Iterable.<module:engine/model/range~Range>} ranges
 * @return {Array.<module:engine/model/range~Range>}
 */

export function sortRanges(ranges) {
  return Array.from(ranges).sort(compareRangeOrder);
} // Helper method to get an object with `first` and `last` indexes from an unsorted array of indexes.

function getFirstLastIndexesObject(indexes) {
  var allIndexesSorted = indexes.sort(function (indexA, indexB) {
    return indexA - indexB;
  });
  var first = allIndexesSorted[0];
  var last = allIndexesSorted[allIndexesSorted.length - 1];
  return {
    first: first,
    last: last
  };
}

function compareRangeOrder(rangeA, rangeB) {
  // Since table cell ranges are disjoint, it's enough to check their start positions.
  var posA = rangeA.start;
  var posB = rangeB.start; // Checking for equal position (returning 0) is not needed because this would be either:
  // a. Intersecting range (not allowed by model)
  // b. Collapsed range on the same position (allowed by model but should not happen).

  return posA.isBefore(posB) ? -1 : 1;
} // Calculates the area of a maximum rectangle that can span over the provided row & column indexes.
//
// @param {Array.<Number>} rows
// @param {Array.<Number>} columns
// @returns {Number}


function getBiggestRectangleArea(rows, columns) {
  var rowsIndexes = Array.from(rows.values());
  var columnIndexes = Array.from(columns.values());
  var lastRow = Math.max.apply(Math, _toConsumableArray(rowsIndexes));
  var firstRow = Math.min.apply(Math, _toConsumableArray(rowsIndexes));
  var lastColumn = Math.max.apply(Math, _toConsumableArray(columnIndexes));
  var firstColumn = Math.min.apply(Math, _toConsumableArray(columnIndexes));
  return (lastRow - firstRow + 1) * (lastColumn - firstColumn + 1);
} // Checks if the selection does not mix a header (column or row) with other cells.
//
// For instance, in the table below valid selections consist of cells with the same letter only.
// So, a-a (same heading row and column) or d-d (body cells) are valid while c-d or a-b are not.
//
//		 header columns
//		  ↓   ↓
//		┌───┬───┬───┬───┐
//		│ a │ a │ b │ b │  ← header row
//		├───┼───┼───┼───┤
//		│ c │ c │ d │ d │
//		├───┼───┼───┼───┤
//		│ c │ c │ d │ d │
//		└───┴───┴───┴───┘


function areCellInTheSameTableSection(tableCells) {
  var table = tableCells[0].findAncestor('table');
  var rowIndexes = getRowIndexes(tableCells);
  var headingRows = parseInt(table.getAttribute('headingRows') || 0); // Calculating row indexes is a bit cheaper so if this check fails we can't merge.

  if (!areIndexesInSameSection(rowIndexes, headingRows)) {
    return false;
  }

  var headingColumns = parseInt(table.getAttribute('headingColumns') || 0);
  var columnIndexes = getColumnIndexes(tableCells); // Similarly cells must be in same column section.

  return areIndexesInSameSection(columnIndexes, headingColumns);
} // Unified check if table rows/columns indexes are in the same heading/body section.


function areIndexesInSameSection(_ref, headingSectionSize) {
  var first = _ref.first,
      last = _ref.last;
  var firstCellIsInHeading = first < headingSectionSize;
  var lastCellIsInHeading = last < headingSectionSize;
  return firstCellIsInHeading === lastCellIsInHeading;
}